import React from 'react'
export default function InquiryModal({ isOpen, onClose, product, onSendInquiry }) {
    const [message, setMessage] = React.useState('');
    const [isSending, setIsSending] = React.useState(false);
    const [error, setError] = React.useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsSending(true);
        try {
            await onSendInquiry(message);
            // The parent component will handle closing the modal on success
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-8 max-w-lg w-full">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-900">Inquiry for: {product.name}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>
                <p className="text-sm text-gray-600 mb-4">
                    Your contact details will be sent to the admin along with your message. They will contact you to facilitate the process.
                </p>
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="inquiry_message" className="block text-sm font-medium text-gray-700">Your Message</label>
                            <textarea
                                id="inquiry_message"
                                name="inquiry_message"
                                rows="4"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                                placeholder="e.g., I'm interested in renting this for a project starting next month..."
                            ></textarea>
                        </div>
                        {error && <div className="text-red-500 text-sm">{error}</div>}
                        <div className="flex justify-end space-x-4">
                            <button type="button" onClick={onClose} className="bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300">Cancel</button>
                            <button type="submit" disabled={isSending} className="primary-gradient text-white py-2 px-4 rounded-lg hover:opacity-90 disabled:opacity-50">
                                {isSending ? 'Sending...' : 'Send Inquiry'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

